import { decode as decodeHtml } from 'html-entities';
import { EntSignatureDisplayType } from './mail_action_store_model';
import { apis } from '@/config';
import { api } from '@/api/api';
import { shouldSkipPersonalSign } from '@/api/logical/mail';
class MailSignatureImplApi {
    constructor() {
        this.dbName = 'mail_new';
        this.signatureTableName = 'signature';
        this.name = apis.mailSignatureImplApi;
        this.systemApi = api.getSystemApi();
        this.http = api.getDataTransApi();
        this.DBApi = api.getNewDBApi();
        this.storeApi = api.getDataStoreApi();
        this.mailConfApi = api.requireLogicalApi(apis.mailConfApiImpl);
        this.htmlApi = api.requireLogicalApi(apis.htmlApi);
        this.eventApi = api.getEventApi();
    }
    init() {
        return this.name;
    }
    afterInit() {
        this.DBApi.initDb(this.dbName);
        return this.name;
    }
    getSid(_account) {
        const user = this.systemApi.getCurrentUser(_account);
        return (user === null || user === void 0 ? void 0 : user.sessionId) || '';
    }
    getCharAvatar(name) {
        if (typeof name !== 'string' || !name || !name.trim()) {
            return name;
        }
        let resChar;
        try {
            name = name.trim();
            const charList = [...name];
            resChar = charList[0];
            const hasCharacter = /[\u4e00-\u9fa5]/.test(name);
            if (hasCharacter) {
                resChar = charList.slice(-2).join('');
            }
            if (resChar.length === 1 && /[a-z]/.test(resChar)) {
                resChar = resChar.toLocaleUpperCase();
            }
        }
        catch (e) {
            console.warn(e);
        }
        return resChar;
    }
    getName(_account) {
        const user = this.systemApi.getCurrentUser(_account);
        return this.getCharAvatar((user === null || user === void 0 ? void 0 : user.nickName) || (user === null || user === void 0 ? void 0 : user.accountName) || '');
    }
    transUserAddItemToArray(info) {
        var _a;
        const userAddItem = (_a = info === null || info === void 0 ? void 0 : info.signInfoDTO) === null || _a === void 0 ? void 0 : _a.userAddItem;
        if (userAddItem) {
            const res = [];
            const list = [];
            Object.keys(userAddItem).forEach(item => {
                const index = item.split('key')[1];
                if (index !== undefined) {
                    res[Number(index)] = userAddItem[item];
                }
                else {
                    list.push(userAddItem[item]);
                }
            });
            info.signInfoDTO.userAddItem = res.filter(item => item !== undefined).concat(list);
        }
        return info;
    }
    buildUrl(url, query) {
        return this.http.buildUrl(url, query);
    }
    transUserAddItemToMap(info) {
        if (info.userAddItem) {
            info.userAddItem = info.userAddItem.reduce((obj, cur, index) => {
                obj['key' + index] = cur;
                return obj;
            }, {});
        }
        return info;
    }
    async handlePromise(promise, handleData) {
        try {
            const res = await promise;
            const data = res.data;
            return this.getCommonRes(data, handleData);
        }
        catch (e) {
            return {
                success: false,
            };
        }
    }
    notifyIntercept(res, req) {
        const { data } = res || {};
        if ((data === null || data === void 0 ? void 0 : data.riskToken) && (data === null || data === void 0 ? void 0 : data.url)) {
            this.eventApi.sendSysEvent({
                eventName: 'RiskHitInterrupt',
                eventData: {
                    code: 'FA_RISK_HIT_INTERRUPT',
                    operate: data === null || data === void 0 ? void 0 : data.operate,
                    url: data === null || data === void 0 ? void 0 : data.url,
                },
                _account: req === null || req === void 0 ? void 0 : req._account,
            });
        }
    }
    getCommonRes(resData, handleData) {
        this.notifyIntercept(resData, { _account: resData === null || resData === void 0 ? void 0 : resData._account });
        if ((resData === null || resData === void 0 ? void 0 : resData.success) && resData.data) {
            let { data } = resData;
            if (handleData) {
                data = handleData(data);
            }
            return {
                data,
                success: true,
            };
        }
        return {
            success: false,
            message: resData === null || resData === void 0 ? void 0 : resData.message,
        };
    }
    async doGetSignList(params, _account) {
        const url = this.systemApi.getUrl('getSignList');
        const sid = this.getSid(_account);
        const { data, suc } = await this.storeApi.get('isFirstGet', { _account });
        const defaultParams = {
            sid,
            isFirstGet: suc && data === 'true',
            needHtmlContent: false,
        };
        params = params ? Object.assign(params, defaultParams) : defaultParams;
        const res = await this.handlePromise(this.http.get(url, Object.assign({}, params), { _account }), sigData => sigData.map(item => this.transUserAddItemToArray(item)));
        if (res.success) {
            this.storeApi.put('isFirstGet', 'true', { _account });
        }
        return res;
    }
    async doGetDefaultSignInDb(writeType, _account) {
        let personalType = 'common';
        if (['replyWithAttach', 'replyAllWithAttach', 'reply', 'replyAll'].includes(writeType || '')) {
            personalType = 'reply';
        }
        if (['forward'].includes(writeType || '')) {
            personalType = 'forward';
        }
        const currentUser = this.systemApi.getCurrentUser(_account);
        const email = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) || '';
        const result = (await this.DBApi.getById({
            tableName: this.signatureTableName,
            dbName: this.dbName,
        }, `${email}_${personalType}_ent`));
        if (result) {
            return {
                content: result.content,
                enable: true,
            };
        }
        return {
            content: '',
            enable: false,
        };
    }
    async doGetDefaultSignInServer(writeType, _account) {
        const personal = this.doGetSignList({}, _account);
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        const ent = isCorpMail ? Promise.resolve({ content: '', isDefault: false, enable: false }) : this.mailConfApi.getEntSignature(false, _account);
        return Promise.all([personal, ent])
            .then(async (r) => {
            var _a, _b, _c, _d, _e;
            const defaultSigModel = (_b = (_a = r[0]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.find(item => {
                if (['replyWithAttach', 'replyAllWithAttach', 'reply', 'replyAll'].includes(writeType || '')) {
                    return item.signInfoDTO.defaultItem.reply;
                }
                if (['forward'].includes(writeType || '')) {
                    return item.signInfoDTO.defaultItem.forward;
                }
                return item.signInfoDTO.defaultItem.compose;
            });
            const skipPersonalSign = shouldSkipPersonalSign(r[1]);
            let resContent = !skipPersonalSign && (defaultSigModel === null || defaultSigModel === void 0 ? void 0 : defaultSigModel.divContent) ? `<div class="mail-signature">${defaultSigModel === null || defaultSigModel === void 0 ? void 0 : defaultSigModel.divContent}</div>` : '';
            if (r[1] && r[1].content) {
                const editable = r[1].display === EntSignatureDisplayType.ReadAndWrite;
                const signAttrs = [];
                if (!editable) {
                    signAttrs.push('contenteditable="false"');
                }
                r[1].content = `<div class="mail-signature-ent" ${signAttrs.join(' ')}>${decodeHtml(r[1].content, { level: 'html5' }) || ''}</div>`;
                r[1].content = r[1].content.replace(/>\s+</g, '><');
                const s = r[1].isDefault ? this.htmlApi.mergeHtmlStr(resContent, r[1].content) : this.htmlApi.mergeHtmlStr(r[1].content, resContent);
                resContent = r[1].enable ? s : resContent;
                resContent = resContent.replace(/>\s+</g, '><');
            }
            const defaultSignChange = await this.defaultSignDiffs(resContent, writeType, _account);
            return {
                enable: true,
                defaultSignChange,
                content: resContent,
                personalSignList: (_c = r[0]) === null || _c === void 0 ? void 0 : _c.data,
                display: (_e = (_d = r[1]) === null || _d === void 0 ? void 0 : _d.display) !== null && _e !== void 0 ? _e : EntSignatureDisplayType.ReadAndWrite,
            };
        })
            .catch(() => ({
            content: '',
            enable: false,
            display: EntSignatureDisplayType.ReadAndWrite,
        }));
    }
    async defaultSignDiffs(content, writeType, _account) {
        let personalType = 'common';
        if (['replyWithAttach', 'replyAllWithAttach', 'reply', 'replyAll'].includes(writeType || '')) {
            personalType = 'reply';
        }
        if (['forward'].includes(writeType || '')) {
            personalType = 'forward';
        }
        const dbResult = await this.doGetDefaultSignInDb(writeType, _account);
        if (dbResult.content !== content) {
            const currentUser = this.systemApi.getCurrentUser(_account);
            const email = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) || '';
            this.DBApi.put({
                tableName: this.signatureTableName,
                dbName: this.dbName,
            }, {
                id: `${email}_${personalType}_ent`,
                type: `${email}_${personalType}_ent`,
                signId: undefined,
                content,
            }).then();
            return true;
        }
        return false;
    }
    async doGetDefaultSign(noCache, writeType, _account) {
        if (noCache) {
            return this.doGetDefaultSignInServer(writeType, _account);
        }
        const dbResult = await this.doGetDefaultSignInDb(writeType, _account);
        if (dbResult && dbResult.enable) {
            return dbResult;
        }
        return this.doGetDefaultSignInServer(writeType, _account);
    }
    doGetSignDetail(id) {
        const url = this.systemApi.getUrl('getSignDetail');
        return this.handlePromise(this.http.get(url, { id }), data => this.transUserAddItemToArray(data));
    }
    doGetSignTemplateAndProfile(avatarDisplayName, _account) {
        avatarDisplayName = avatarDisplayName || this.getName(_account);
        const url = this.systemApi.getUrl('getSignTemplateAndProfile');
        return this.handlePromise(this.http.get(url, { avatarDisplayName }, { _account }));
    }
    async doGetSignPreview(params, _account) {
        var _a, _b;
        const url = this.systemApi.getUrl('getSignPreview');
        const { signInfo } = params;
        if (!signInfo.profilePhoto) {
            const res = await this.doGetSignTemplateAndProfile(undefined, _account);
            if (res.success && ((_a = res.data) === null || _a === void 0 ? void 0 : _a.profile)) {
                signInfo.profilePhoto = (_b = res.data) === null || _b === void 0 ? void 0 : _b.profile;
            }
            else {
                return {
                    success: false,
                };
            }
        }
        params.signInfo = this.transUserAddItemToMap(signInfo);
        return this.handlePromise(this.http.post(url, params, Object.assign({ contentType: 'json' }, { _account })));
    }
    async doAddSign(params, _account) {
        var _a, _b;
        let url = '';
        if (params.rtxContent) {
            url = this.systemApi.getUrl('addCustomizeSign');
        }
        else {
            url = this.systemApi.getUrl('addSign');
            if (!params.profilePhoto) {
                const res = await this.doGetSignTemplateAndProfile(undefined, _account);
                if (res.success && ((_a = res.data) === null || _a === void 0 ? void 0 : _a.profile)) {
                    params.profilePhoto = (_b = res.data) === null || _b === void 0 ? void 0 : _b.profile;
                }
                else {
                    return {
                        success: false,
                    };
                }
            }
            params = this.transUserAddItemToMap(params);
        }
        url = this.buildUrl(url, { riskHitIntercept: true });
        return this.handlePromise(this.http.post(url, params, Object.assign({ contentType: 'json' }, { _account })));
    }
    doSetDefaultSign(params, _account) {
        const url = this.systemApi.getUrl('setDefaultSign');
        return this.handlePromise(this.http.post(url, params, Object.assign({ contentType: 'json' }, { _account })));
    }
    doUpdateSign(params, _account) {
        let url = '';
        let handle;
        if (params.rtxContent) {
            url = this.systemApi.getUrl('updateCustomizeSign');
        }
        else {
            url = this.systemApi.getUrl('updateSign');
            params = this.transUserAddItemToMap(params);
            handle = (data) => this.transUserAddItemToArray(data);
        }
        url = this.buildUrl(url, { riskHitIntercept: true });
        return this.handlePromise(this.http.post(url, params, Object.assign({ contentType: 'json' }, { _account })), handle);
    }
    doDeleteSign(signId, _account) {
        const url = this.http.buildUrl(this.systemApi.getUrl('delSign'), { signId });
        return this.handlePromise(this.http.post(url, {}, { _account }));
    }
    doUploadSignAvatar(file) {
        const url = this.systemApi.getUrl('uploadSignAvatar');
        const fileFormData = new FormData();
        fileFormData.append('picFile', file);
        return this.handlePromise(this.http.post(url, fileFormData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            contentType: 'stream',
        }));
    }
    doGetSignTemplate() {
        const url = this.systemApi.getUrl('getSignTemplate');
        return this.handlePromise(this.http.get(url));
    }
}
const mailSignatureImplApi = new MailSignatureImplApi();
api.registerLogicalApi(mailSignatureImplApi);
export default mailSignatureImplApi;
